module.exports = __webpack_public_path__ + "media/application/images/2018/email-red-ab81c41e11792d757fe202ea615b9dd6.svg";